import { TrashIcon } from '@heroicons/react/16/solid';
import uniqueId from 'lodash.uniqueid';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const SKUModal = ({
	isOpen = false,
	currentSKUs,
	availableSKUs = [],
	onCancel,
	onChangeSKUs,
}) => {
	const modalRef = useRef();
	const [chosenSKU, setChosenSKU] = useState(0);
	const [localSKUs, setLocalSKUs] = useState([]);
	const [showAddAnother, setShowAddAnother] = useState(false);
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
			setLocalSKUs(currentSKUs);
		} else {
			setChosenSKU(0);
			setLocalSKUs([]);
		}
	}, [isOpen]);
	useEffect(() => {
		if (chosenSKU !== 0) {
			const selectedSKU = availableSKUs.find(
				(sku) => sku.id === parseInt(chosenSKU, 10),
			);
			setLocalSKUs([
				...localSKUs,
				{ id: uniqueId('new-sku-'), taxonomy_sku: selectedSKU },
			]);
			setChosenSKU(0);
			setShowAddAnother(false);
		}
	}, [chosenSKU]);

	const handleUpdateSKUs = () => {
		onChangeSKUs(localSKUs);
	};

	const filteredAvailableSKUs = availableSKUs.filter(
		(sku) => !localSKUs.find((localSKU) => localSKU.taxonomy_sku.id === sku.id),
	);

	return (
		<dialog id="sku-dialog" className="modal" ref={modalRef}>
			<div className="modal-box">
				<div className="flex items-center justify-between mb-4">
					<h3>Edit SKUs</h3>
					<button
						className="btn btn-sm btn-primary"
						onClick={() => setShowAddAnother(true)}
						disabled={showAddAnother || filteredAvailableSKUs.length === 0}
					>
						Add
					</button>
				</div>
				<table className="table w-full mb-4">
					<thead>
						<tr>
							<th>SKU Number</th>
							<th>Label</th>
						</tr>
					</thead>
					<tbody>
						{localSKUs.length === 0 && (
							<tr>
								<td colSpan={2}>No SKUs assigned</td>
							</tr>
						)}
						{localSKUs?.map(({ id, taxonomy_sku }) => (
							<tr key={`current-sku-${id}`}>
								<td>{taxonomy_sku.sku_number}</td>
								<td className="flex items-center justify-between">
									<div>{taxonomy_sku.label}</div>
									<button
										type="button"
										className="btn btn-xs btn-circle btn-ghost"
										onClick={() =>
											setLocalSKUs(localSKUs.filter((sku) => sku.id !== id))
										}
									>
										<TrashIcon className="w-4 h-4" />
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{showAddAnother && (
					<div className="py-4 form-control">
						<label htmlFor="sku" className="label">
							SKU
						</label>
						<select
							id="sku"
							className="select select-bordered select-sm"
							value={chosenSKU}
							onChange={({ target }) => setChosenSKU(target.value)}
							autoComplete="off"
							required
						>
							<option disabled value="0">
								Choose...
							</option>
							{filteredAvailableSKUs?.map((sku) => (
								<option key={`${sku.id}`} value={sku.id}>
									{sku.sku_number} - {sku.label}
								</option>
							))}
						</select>
					</div>
				)}
				<div className="modal-action">
					<form method="dialog">
						<button className="btn" onClick={onCancel}>
							Cancel
						</button>
						<button className="ml-4 btn btn-primary" onClick={handleUpdateSKUs}>
							Save
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

SKUModal.propTypes = {
	isOpen: PropTypes.bool,
	onCancel: PropTypes.func.isRequired,
	currentSKUs: PropTypes.array,
	availableSKUs: PropTypes.array,
	onChangeSKUs: PropTypes.func.isRequired,
};

export default SKUModal;
